import type * as React from "react";

import { SecurityMfaEmailConfirmFeature } from "@/features/Security/Mfa/Email/SecurityMfaEmailConfirmFeature";

const SecurityMfaEmailConfirmPage: React.FC = () => {
  return <SecurityMfaEmailConfirmFeature />;
};

export default SecurityMfaEmailConfirmPage;
